import React from 'react';
import {NgageSpinner} from "../../NgageSpinner";

type Props = {
    isLoading?: boolean
    children?: React.ReactNode
}

function TableBody(props: Props) {
    const {isLoading, children} = props

    if(isLoading){
        return (
            <tbody>
                <tr className="bg-white">
                    <td colSpan={100}>
                        <div className="py-4 flex justify-center">
                            <NgageSpinner size={NgageSpinner.sizes.MEDIUM} color={NgageSpinner.colors.BRAND}/>
                        </div>
                    </td>
                </tr>
            </tbody>
        )
    }

    return (
        <tbody>{children}</tbody>
    );
}

export default TableBody;